import PrintImageButton from './PrintImageButton';

export default PrintImageButton;
